import { useTranslation } from 'react-i18next';
import Footer from '../Components/HomePageComponents/Footer';
import 'bootstrap/dist/css/bootstrap.min.css';

function TermsPage() {
  const { i18n } = useTranslation();
  const isFrench = i18n.language === 'fr';

  return (
    <div style={{ backgroundColor: '#F0F0F0' }}>
      <div style={{ paddingTop: '2rem' }}>
        <div className="row">
          <div className="col-md-12">
            {isFrench ? (
              <>
                <h2>Conditions d'utilisation</h2>
                <p>
                  Ces conditions générales régissent votre utilisation du logiciel de planification offert par Technologies Flagpole. En accédant à notre service ou en l'utilisant, vous acceptez d'être lié par ces conditions.
                </p>

                <h3>1. Services d'abonnement</h3>
                <p>
                  <strong>1.1. Description du service :</strong> Notre service fournit un logiciel de planification accessible derrière un abonnement payant. Les utilisateurs peuvent créer, gérer et partager des horaires via notre plateforme.
                </p>
                <p>
                  <strong>1.2. Plans d'abonnement :</strong> Nous offrons plusieurs forfaits avec des fonctionnalités et des prix différents. En souscrivant à notre service, vous acceptez de payer les frais associés au plan choisi.
                </p>
                <p>
                  <strong>1.3. Paiement et renouvellement :</strong> Les frais d'abonnement sont payés d'avance et renouvelés automatiquement à la fin de chaque période, sauf annulation par l'utilisateur. Le non-paiement peut entraîner la suspension ou la fermeture de votre compte.
                </p>

                <h3>2. Responsabilités de l'utilisateur</h3>
                <p>
                  <strong>2.1. Enregistrement :</strong> Vous devez créer un compte pour accéder à notre service. Vous acceptez de fournir des informations exactes et complètes lors de l'inscription et de les mettre à jour si nécessaire.
                </p>
                <p>
                  <strong>2.2. Sécurité :</strong> Vous êtes responsable de la sécurité de vos identifiants et de toute activité effectuée sous votre compte. Vous devez nous informer immédiatement de toute utilisation non autorisée.
                </p>
                <p>
                  <strong>2.3. Utilisation acceptable :</strong> Vous acceptez d'utiliser notre service conformément aux lois applicables et à ces conditions. Vous ne devez pas nuire au service ou perturber l'usage des autres utilisateurs.
                </p>

                <h3>3. Propriété intellectuelle</h3>
                <p>
                  <strong>3.1. Propriété :</strong> Notre service et ses droits de propriété intellectuelle sont la propriété de l'entreprise ou de ses concédants. Vous n'acquérez aucun droit de propriété sur le service.
                </p>
                <p>
                  <strong>3.2. Licence :</strong> Sous réserve de ces conditions, nous vous accordons une licence limitée, non exclusive et non transférable pour accéder au service pendant la période d'abonnement.
                </p>

                <h3>4. Limitation de responsabilité</h3>
                <p>
                  <strong>4.1. Avertissement :</strong> Notre service est fourni "tel quel" sans garantie de quelque nature que ce soit. Nous excluons toute garantie de qualité marchande, d'adaptation à un usage particulier et de non-contrefaçon.
                </p>
                <p>
                  <strong>4.2. Limitation :</strong> Nous ne serons en aucun cas responsables des dommages indirects, accessoires, spéciaux, consécutifs ou punitifs découlant de l'utilisation de notre service.
                </p>

                <h3>5. Résiliation</h3>
                <p>
                  <strong>5.1. Résiliation par l'utilisateur :</strong> Vous pouvez annuler votre abonnement à tout moment selon la procédure indiquée dans le service. L'accès prend fin à la fin de la période d'abonnement en cours.
                </p>
                <p>
                  <strong>5.2. Résiliation par l'entreprise :</strong> Nous nous réservons le droit de suspendre ou de mettre fin à votre accès si vous violez ces conditions ou si vous ne payez pas vos frais d'abonnement.
                </p>

                <h3>6. Droit applicable</h3>
                <p>
                  <strong>6.1. </strong> Ces conditions sont régies par les lois de l'Ontario, Canada, sans égard à ses règles de conflit de lois.
                </p>

                <h3>7. Intégralité de l'accord</h3>
                <p>
                  <strong>7.1. </strong> Ces conditions constituent l'accord complet entre vous et l'entreprise sur le sujet traité et remplacent tous accords antérieurs.
                </p>

                <br />
                <h2>Politique de confidentialité</h2>
                <p>
                  Cette politique décrit comment Technologies Flagpole collecte, utilise et divulgue les informations personnelles lorsque vous utilisez notre site et nos services.
                </p>
                <p>
                  Nous pouvons collecter les informations de contact, les informations de paiement, ainsi que les informations d'utilisation pour fournir les services, traiter les paiements et améliorer l'expérience utilisateur.
                </p>
                <p>
                  Les données sont conservées selon les besoins de nos services et de la conformité légale. Nous prendons des mesures raisonnables pour protéger les informations, mais aucune transmission sur Internet n'est totalement sécurisée.
                </p>
                <p>
                  Technologies Flagpole <br />
                  <a href="mailto:support@flagpoletech.ca">support@flagpoletech.ca</a> <br />
                  {new Date().getFullYear()}
                </p>
              </>
            ) : (
              <>
                <h2>Terms and Conditions</h2>
                <p>
                  These Terms and Conditions ("Agreement") govern your use of the scheduling software service provided by Flagpole Technologies ("Company," "we," "us," or "our"). By accessing or using our service, you agree to be bound by the terms and conditions of this Agreement.
                </p>

                <h3>1. Subscription Services</h3>
                <p>
                  <strong>1.1. Description of Service:</strong> Our service provides scheduling software accessible behind a paywall user subscription. Users can create, manage, and share schedules through our platform.
                </p>
                <p>
                  <strong>1.2. Subscription Plans:</strong> We offer various subscription plans with different features and pricing. By subscribing to our service, you agree to pay the subscription fees associated with your chosen plan.
                </p>
                <p>
                  <strong>1.3. Payment and Renewal:</strong> Subscription fees are payable in advance and automatically renewed at the end of each subscription period unless canceled by the user. Failure to pay subscription fees may result in the suspension or termination of your account.
                </p>

                <h3>2. User Responsibilities</h3>
                <p>
                  <strong>2.1. Account Registration:</strong> You must register an account to access our service. You agree to provide accurate and complete information during the registration process and to update your information to keep it accurate and current.
                </p>
                <p>
                  <strong>2.2. Security:</strong> You are responsible for maintaining the security of your account credentials and for any activities that occur under your account. You agree to notify us immediately of any unauthorized use of your account or any other security breach.
                </p>
                <p>
                  <strong>2.3. Acceptable Use:</strong> You agree to use our service in compliance with all applicable laws, regulations, and this Agreement. You shall not engage in any conduct that may harm our service or interfere with the use of our service by other users.
                </p>

                <h3>3. Intellectual Property</h3>
                <p>
                  <strong>3.1. Ownership:</strong> Our service and all related intellectual property rights are owned by the Company or its licensors. You shall not acquire any ownership interest in our service or any content provided through our service.
                </p>
                <p>
                  <strong>3.2. License:</strong> Subject to the terms of this Agreement, we grant you a limited, non-exclusive, non-transferable license to access and use our service solely for your internal business purposes during the subscription period.
                </p>

                <h3>4. Limitation of Liability</h3>
                <p>
                  <strong>4.1. Disclaimer:</strong> Our service is provided on an "as-is" and "as-available" basis without warranties of any kind, either express or implied. We disclaim all warranties, including but not limited to warranties of merchantability, fitness for a particular purpose, and non-infringement.
                </p>
                <p>
                  <strong>4.2. Limitation of Liability:</strong> In no event shall the Company be liable for any indirect, incidental, special, consequential, or punitive damages arising out of or in connection with this Agreement or the use of our service, even if we have been advised of the possibility of such damages.
                </p>

                <h3>5. Termination</h3>
                <p>
                  <strong>5.1. Termination by User:</strong> You may cancel your subscription at any time by following the cancellation procedure provided in our service. Upon cancellation, your access to our service will be terminated at the end of your current subscription period.
                </p>
                <p>
                  <strong>5.2. Termination by Company:</strong> We reserve the right to suspend or terminate your access to our service at any time for any reason, including but not limited to violation of this Agreement or non-payment of subscription fees.
                </p>

                <h3>6. Governing Law</h3>
                <p>
                  <strong>6.1. </strong> This Agreement shall be governed by and construed in accordance with the laws of Ontario, Canada, without regard to its conflict of law principles.
                </p>

                <h3>7. Entire Agreement</h3>
                <p>
                  <strong>7.1. </strong> This Agreement constitutes the entire agreement between you and the Company with respect to the subject matter hereof and supersedes all prior and contemporaneous agreements and understandings, whether written or oral, relating to such subject matter.
                </p>

                <br></br>
                <br></br>
                <h2>User Agreement</h2>
                <p>
                  This User Agreement ("Agreement") is entered into by and between Flagpole Technologies ("Company") and the user ("User") accessing or using the Company's software subscription service ("Service"). By accessing or using the Service, User agrees to be bound by the terms and conditions set forth in this Agreement.
                </p>

                <h3>1. License:</h3>
                <p>
                  <strong>1.1. </strong> Subject to the terms of this Agreement, Company grants User a limited, non-exclusive, non-transferable, and revocable license to access and use the software provided through the Service solely for User's internal business purposes during the subscription period.
                </p>
                <p>
                  <strong>1.2. </strong> User shall not:
                  <ul>
                    <li>a) Modify, adapt, translate, reverse engineer, decompile, or disassemble the software.</li>
                    <li>b) Sell, lease, sublicense, distribute, or otherwise transfer the software or any rights therein.</li>
                    <li>c) Use the software in any unlawful manner, for any unlawful purpose, or in any manner inconsistent with this Agreement.</li>
                  </ul>
                </p>

                <h3>2. Subscription:</h3>
                <p>
                  <strong>2.1. </strong> User shall pay the subscription fees in accordance with the pricing plan selected by User. The subscription fees are non-refundable.
                </p>
                <p>
                  <strong>2.2. </strong> The subscription period shall commence upon User's acceptance of this Agreement and shall continue for the duration specified in the subscription plan.
                </p>
                <p>
                  <strong>2.3. </strong> Company reserves the right to change the subscription fees and pricing plans at any time. Changes to the subscription fees will be effective upon renewal of the subscription period.
                </p>

                <h3>3. Intellectual Property:</h3>
                <p>
                <strong>3.1. </strong> User acknowledges that the software and all related intellectual property rights are owned by Company or its licensors. User shall not acquire any ownership interest in the software.
                </p>
                <p>
                <strong>3.2. </strong> User grants Company a non-exclusive, royalty-free, worldwide license to use, reproduce, display, and distribute any content or data uploaded, transmitted, or otherwise provided by User through the Service for the purpose of providing and improving the Service.
                </p>

                <h3>4. Privacy:</h3>
                <p>
                <strong>4.1. </strong> Company may collect and use personal information in accordance with its Privacy Policy, which is hereby incorporated into this Agreement by reference. By using the Service, User consents to the collection and use of personal information as described in the Privacy Policy.
                </p>

                <h3>5. Termination:</h3>
                <p>
                <strong>5.1. </strong> Either party may terminate this Agreement upon written notice if the other party breaches any material term of this Agreement and fails to cure such breach within 30 days of receiving written notice thereof.
                </p>
                <p>
                <strong>5.2. </strong> Upon termination of this Agreement, User's access to the Service will be terminated, and User shall immediately cease all use of the software.
                </p>

                <h3>6. Limitation of Liability:</h3>
                <p>
                <strong>6.1. </strong> In no event shall Company be liable for any indirect, incidental, special, consequential, or punitive damages, including but not limited to lost profits, arising out of or in connection with this Agreement or the use of the Service, even if Company has been advised of the possibility of such damages.
                </p>
                <p>
                  By accessing or using the Service, User acknowledges that they have read, understood, and agree to be bound by the terms and conditions of this Agreement.
                </p>

                <br></br>
                <br></br>
                <h2>Disclaimer Policy</h2>
                <p>
                  This disclaimer policy ("Policy") applies to your use of the scheduling software service provided by Flagpole Technologies ("Company," "we," "us," or "our"). By accessing or using our service, you acknowledge and agree to be bound by this Policy.
                </p>
                <h3>1. Third-Party Links</h3>
                <p>
                  <strong>1.1. YouTube Links:</strong> Our service may contain links to videos hosted on YouTube. These links are provided for informational purposes only, and we do not endorse, control, or guarantee the accuracy, relevance, or legality of the content on YouTube. By clicking on these links, you acknowledge that you are leaving our platform and accessing content on a third-party website. We are not responsible for any content, products, services, or practices of YouTube or its affiliates.
                </p>
                <p>
                  <strong>1.2. Stripe Payment Processing:</strong> Our service utilizes Stripe, a third-party payment processor, to process payments securely. When you make purchases through our website, you will be redirected to Stripe's platform to enter your payment information. Please note that Stripe collects and processes your payment information independently of our service. We do not store your payment information directly on our servers. By using our service, you acknowledge and agree to be bound by Stripe's terms of service and privacy policy. We are not responsible for any issues, errors, or disputes related to payment processing through Stripe.
                </p>

                <h3>2. No Professional Advice</h3>
                <p>
                <strong>2.1. </strong> Our service may contain information, advice, or recommendations related to scheduling and business management. However, this information is provided for general informational purposes only and should not be construed as professional advice. We make no representations or warranties of any kind, express or implied, about the accuracy, completeness, reliability, or suitability of the information provided. You acknowledge that any reliance you place on such information is strictly at your own risk. We recommend consulting with a qualified professional advisor before making any decisions based on the information provided through our service.
                </p>

                <h3>3. Limitation of Liability</h3>
                <p>
                <strong>3.1. </strong> We make no representations or warranties, express or implied, regarding the availability, accuracy, completeness, reliability, or suitability of our service or the content provided therein. We shall not be liable for any direct, indirect, incidental, special, consequential, or punitive damages arising out of or in connection with your use of our service or any content accessed through our service.
                </p>

                <h3>4. Changes to Policy</h3>
                <p>
                <strong>4.1. </strong> We reserve the right to modify or update this Policy at any time without prior notice. Any changes will be effective immediately upon posting the updated Policy on our website. Your continued use of our service after the posting of any changes to this Policy constitutes your acceptance of such changes.
                </p>

                <br></br>
                <br></br>
                <h2>Privacy Policy</h2>
                <p>
                  This Privacy Policy describes how Flagpole Technologies ("Company," "we," "us," or "our") collects, uses, and discloses personal information when you use our website and services.
                </p>

                <h3>1. Information We Collect</h3>
                <p>
                  We collect the following types of personal information when you use our website and services:
                </p>
                <ul>
                  <li>Contact Information: Your name, email address, phone number, and mailing address.</li>
                  <li>Payment Information: When you make purchases through our website, we collect payment information, including credit card details and other payment information. However, we do not store your payment information directly on our servers. Instead, all payment transactions are securely processed through our third-party payment processor, Stripe. Please note that while we do not store your payment information, we may have access to view payment details within our Stripe account for transaction management and record-keeping purposes.</li>
                  <li>Usage Information: Information about how you use our website and services, including your IP address, browser type, operating system, referral URLs, and pages visited.</li>
                </ul>

                <h3>2. How We Use Your Information</h3>
                <p>
                  We use the personal information we collect for the following purposes:
                </p>
                <ul>
                  <li>To provide and maintain our services.</li>
                  <li>To process payments securely and prevent fraudulent transactions.</li>
                  <li>To communicate with you about your account and provide customer support.</li>
                  <li>To personalize your experience and improve our website and services.</li>
                  <li>To comply with legal and regulatory requirements.</li>
                </ul>

                <h3>3. How We Share Your Information</h3>
                <p>
                  We may share your personal information with the following parties:
                </p>
                <ul>
                  <li>Service Providers: We may share your information with third-party service providers who assist us in providing our services, such as payment processors, hosting providers, and analytics services.</li>
                  <li>Legal Compliance: We may disclose your information if required by law or in response to valid requests from public authorities.</li>
                  <li>Business Transfers: If we are involved in a merger, acquisition, or sale of assets, your information may be transferred as part of that transaction.</li>
                </ul>

                <h3>4. Your Choices</h3>
                <p>
                  You can choose not to provide certain personal information, but this may limit your ability to use certain features of our website and services.
                </p>

                <h3>5. Data Security</h3>
                <p>
                  We take reasonable measures to protect your personal information from unauthorized access, use, or disclosure. However, no method of transmission over the internet or electronic storage is 100% secure, and we cannot guarantee absolute security.
                </p>

                <h3>6. Changes to This Privacy Policy</h3>
                <p>
                  We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page.
                </p>

                <br></br>
                <br></br>
                <h3>Contact Us</h3>
                <p>
                    If you have any questions or concerns about this Policy, please contact us at support@flagpoletech.ca.
                </p>

                <p>
                  By accessing or using our service, you acknowledge that you have read, understood, and agree to be bound by the terms and conditions of this Policy.
                </p>
                <p>
                  Flagpole Technologies <br />
                  <a href="mailto:support@flagpoletech.ca">support@flagpoletech.ca</a> <br />
                  {new Date().getFullYear()}
                </p>
              </>
            )}
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default TermsPage;